// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ws51","field":"styles_field__AE-ld","fieldCol":"styles_fieldCol___W1pT","diffCol":"styles_diffCol__2vltS","diff":"styles_diff__2Xg6W"};